import Comp from './Gallery'

export default Comp
